import { render } from "./StaticTable.vue?vue&type=template&id=32f2c333&scoped=true"
import script from "./StaticTable.vue?vue&type=script&lang=js"
export * from "./StaticTable.vue?vue&type=script&lang=js"

import "./StaticTable.vue?vue&type=style&index=0&id=32f2c333&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2c333"]])

export default __exports__